export enum MatchContextSectionKey {
  MatchComment = 'matchCommentContext',
}

/**
 * Shared between the initial compaction prompt (`AiMatchContextCompactionPrompt`) and the
 * update-on-reply addition in `summarize.node.ts`, so the employer-safe/internal boundary stays
 * identical whichever prompt is deriving it - caught by review: the two prompts had drifted, with
 * the update path missing the exclusion list and the "when in doubt" rule entirely.
 */
export const MATCH_COMMENT_CONTEXT_EMPLOYER_SAFE_RULES =
  "a neutral, factual line an employer could read directly - confirmed dates, agreed next steps, document status. Never salary, health, personal circumstances, competing offers, or anyone's opinion of either party. When in doubt about a fact, put it in internal, not employerSafe - omitting a fact is always safer than leaking one.";

export type MatchContextSectionTimestampField<K extends MatchContextSectionKey> = `${K}UpdatedAt`;

export interface MatchCommentContextSectionData {
  employerSafe: string;
  internal: string;
}

export interface MatchContextSectionDataMap {
  [MatchContextSectionKey.MatchComment]: MatchCommentContextSectionData;
}

type MatchContextSectionFields<K extends MatchContextSectionKey> = Partial<MatchContextSectionDataMap[K]> &
  Partial<Record<MatchContextSectionTimestampField<K>, string | null>>;

type UnionToIntersection<U> = (U extends unknown ? (union: U) => void : never) extends (intersection: infer I) => void ? I : never;

export type CurrentMatchContext = UnionToIntersection<
  { [K in MatchContextSectionKey]: MatchContextSectionFields<K> }[MatchContextSectionKey]
>;
